export enum Environment {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
}
